exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".apple-pay-button {\n  width: 100%;\n  height: 45px;\n  background: #fff;\n  border: 1px solid #000000;\n  display: -ms-flexbox;\n  display: flex;\n  place-content: center;\n  -ms-flex-align: center;\n  align-items: center;\n  font-size: 21px;\n  font-weight: 700;\n  border-radius: 5px;\n  cursor: pointer;\n}\n.apple-pay-button .logo {\n    margin-left: 10px;\n}\n.apple-pay-button .logo img {\n      margin-top: 8px;\n}\n", ""]);

// exports
